export default __webpack_public_path__ + "static/media/tn_logo.7fba0666.svg";